module.exports = __webpack_public_path__ + "static/media/(DH)-Artesanato-23.bd5eb938.jpg";